import { Stack, Typography } from '@mui/material';
import { ImportPanel, ImportTypeSelector, PanelHeader } from '../styles';
import { useRef } from 'react';
import { LegacyData } from '../LegacyData';

export const DataUpload = () => {
  const headerRef = useRef<HTMLDivElement>(null);

  return (
    <Stack width="100%" justifyContent="center" direction="row">
      <ImportPanel>
        <PanelHeader ref={headerRef}>
          <Typography variant="h3" fontWeight={500} color="primary.600">
            Upload data to Abyss Fabric
          </Typography>
          <Typography variant="h5" fontWeight={400} color="primary.400">
            Different data types require different templates. Select the appropriate type below.
          </Typography>
        </PanelHeader>
        <ImportTypeSelector>
          <LegacyData />
        </ImportTypeSelector>
      </ImportPanel>
    </Stack>
  );
};
